import Popup from 'components/popup/popup';
import CustomButton from 'components/CustomInput/Button';
import CustomPagination from 'components/CustomPagination';
import CustomTable from 'components/CustomTable';
import PageSize from 'components/CustomTable/PageSize';
import TextSubHeader from 'components/CustomText/TextSubHeader';
import CustomOutlineSelect from 'components/Input/CustomOutlineSelect';
import CustomTextField from 'components/Input/CustomTextField';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components/macro';
import usePanelCurrentMember from './usePanelCurrentMember';
import usePanelSearchMember from './usePanelSearchMember';
import {
    GET_REVIEW_PANEL_BUY_ID,
    GET_REVIEW_PANEL_MEMBER_LIST,
    ADD_REVIEW_PANEL_DATA,
    EDIT_REVIEW_PANEL_DATA,
} from 'store/key';
import { useDispatch, useSelector } from 'react-redux';
import useDialog from 'components/ConfirmDialog/useDialog';
import { NO_MEMBER_DATA, UPDATED_REVIEW_PANEL, CREATED_REVIEW_PANEL, PANEL_NAME_EXISTED } from 'utility/frontendMessage';
const SLayout = styled.div``;

const PanelAddDialog = ({ isShow, onCancel = () => null, data, refleshReviewPaneList = () => null }) => {
    const dispatch = useDispatch();
    const showDialog = useDialog();
    const { reviewPanelMemberList } = useSelector((state) => state.reviewPanel);
    const { columns: currentColumns } = usePanelCurrentMember();
    const { rows: searchRows, columns: searchColumns, selectedMember, setSelectedMember } = usePanelSearchMember();
    const [panelName, setPanelName] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [isMemberLoading, setIsMemberLoading] = useState(false);
    const [searchCriteria, setSearchCriteria] = useState({
        paramValue: '',
        paramKey: 'firstName',
        page: 1,
        pageSize: 10,
    });
    const [isSeach, setIsSeach] = useState({ paramKey: 'firstName', paramValue: '', page: 1, pageSize: 10 });
    const [forcePanelNameShow, setForcePanelNameShow] = useState(false);

    useEffect(() => {
        if (data && isShow) {
            setIsLoading(true);
            dispatch({
                type: GET_REVIEW_PANEL_BUY_ID,
                payload: {
                    id: data.id,
                    callback: (res) => {
                        setSelectedMember(res.reviewPanelMemberList);
                        setPanelName(res.reviewPanelName);
                        setIsLoading(false);
                    },
                },
            });
        } else {
            setSelectedMember([]);
            setPanelName('');
            setSearchCriteria({ paramValue: '', paramKey: 'firstName', pageSize: 10, page: 1 });
        }
    }, [data, dispatch, isShow, setSelectedMember]);
    let listOfCriteria = [
        { display: 'Surname', key: 'surname' },
        { display: 'First Name', key: 'firstName' },
    ];
    useEffect(() => {
        getReviewPanelMemberList(searchCriteria);
    }, []);
    const getReviewPanelMemberList = (params) => {
        if (params.paramValue.length >= 255) return;
        setIsMemberLoading(true);
        dispatch({
            type: GET_REVIEW_PANEL_MEMBER_LIST,
            payload: {
                params,
                callback: () => {
                    setIsMemberLoading(false);
                    setIsSeach(params);
                },
            },
        });
    };
    const cancel = () => {
        onCancel();
    };
    const onConfirm = () => {
        let userIds = selectedMember.reduce((group, curP) => group.concat(curP.id), []);
        if (!panelName || panelName.length > 255) {
            setForcePanelNameShow(true);
            return;
        }
        if (userIds.length === 0) {
            showDialog({
                description: NO_MEMBER_DATA,
                disableCancelButton: true,
            });
            return;
        }
        if (data) {
            dispatch({
                type: EDIT_REVIEW_PANEL_DATA,
                payload: {
                    data: {
                        panelName,
                        userIds,
                    },
                    id: data.id,
                    callback: (res) => {
                        if (res.data.status === 'ERROR') {
                            showDialog({
                                description: PANEL_NAME_EXISTED,
                                disableCancelButton: true,
                            });
                        } else {
                            onCancel();
                            refleshReviewPaneList();
                            showDialog({
                                description: UPDATED_REVIEW_PANEL,
                                disableCancelButton: true,
                            });
                        }
                    },
                },
            });
        } else {
            dispatch({
                type: ADD_REVIEW_PANEL_DATA,
                payload: {
                    data: {
                        panelName,
                        userIds,
                    },
                    callback: (res) => {
                        if (res.data.status === 'ERROR') {
                            showDialog({
                                description: PANEL_NAME_EXISTED,
                                disableCancelButton: true,
                            });
                        } else {
                            onCancel();
                            refleshReviewPaneList();
                            showDialog({
                                description: CREATED_REVIEW_PANEL,
                                disableCancelButton: true,
                            });
                        }
                    },
                },
            });
        }
    };
    const deleteRow = (row) => {
        const newSelectedMember = JSON.parse(JSON.stringify(selectedMember));
        const index = newSelectedMember.findIndex((item) => item.id === row.id);
        newSelectedMember.splice(index, 1);
        setSelectedMember(newSelectedMember);
    };
    const handleSearch = () => {
        setSearchCriteria({ ...searchCriteria, page: '1' });
        getReviewPanelMemberList({ ...searchCriteria, page: '1' });
    };
    const handleClear = () => {
        setSearchCriteria({ paramValue: '', paramKey: 'firstName', page: 1, pageSize: 10 });
        getReviewPanelMemberList({ paramValue: '', paramKey: 'firstName', page: 1, pageSize: 10 });
    };
    const setDisabled = () => {
        if (
            isSeach.paramKey === 'firstName' &&
            isSeach.paramValue === '' &&
            isSeach.page === 1 &&
            isSeach.pageSize === 10
        ) {
            return true;
        } else {
            return false;
        }
    };
    return (
        <SLayout>
            <Popup
                width="1100px"
                title={`${data ? 'Edit' : 'Create'} Review Panel`}
                open={isShow}
                footerActions={[
                    { label: 'Cancel', clicked: cancel, color: 'default' },
                    { label: 'Confirm', clicked: onConfirm },
                ]}
                closePopup={cancel}
            >
                <div style={{ width: 1100 }}>
                    <div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <TextSubHeader style={{ flexShrink: 0, paddingRight: 10 }}>Panel Name: </TextSubHeader>

                            <CustomTextField
                                validators={['isRequired']}
                                value={panelName}
                                onChange={(e) => setPanelName(e.target.value)}
                                forceErrorDisplay={forcePanelNameShow}
                                maxLength={255}
                            />
                        </div>

                        <div
                            style={{
                                display: 'flex',
                                marginTop: 15,
                                justifyContent: 'space-between',
                                alignItems: 'center',
                            }}
                        >
                            <TextSubHeader style={{ paddingRight: 10 }}>Add Panel Member: </TextSubHeader>
                            <div style={{ display: 'flex', alignItems: 'center' }}>
                                <div style={{ marginRight: 5 }}>
                                    <CustomOutlineSelect
                                        value={searchCriteria.paramKey}
                                        onChange={(e) => {
                                            setSearchCriteria({
                                                ...searchCriteria,
                                                paramKey: e.target.value,
                                                page: '1',
                                            });
                                            getReviewPanelMemberList({
                                                ...searchCriteria,
                                                page: '1',
                                                paramKey: e.target.value,
                                            });
                                        }}
                                        choices={listOfCriteria}
                                    />
                                </div>
                                <div style={{ width: 300, marginRight: 10 }}>
                                    <CustomTextField
                                        label={'Keyword'}
                                        value={searchCriteria.paramValue}
                                        onChange={(e) => {
                                            setSearchCriteria({ ...searchCriteria, paramValue: e.target.value });
                                        }}
                                        onPressEnter={handleSearch}
                                        maxLength={255}
                                    />
                                </div>
                                <CustomButton onClick={handleSearch} style={{ height: 38 }}>
                                    Search
                                </CustomButton>
                                <CustomButton
                                    style={{ marginLeft: 5, height: 38 }}
                                    onClick={handleClear}
                                    disabled={setDisabled()}
                                >
                                    Reset
                                </CustomButton>
                                <div style={{ paddingLeft: 20 }}>
                                    <PageSize
                                        label={'Page Size'}
                                        value={searchCriteria.pageSize}
                                        onChange={(value) => {
                                            setSearchCriteria({ ...searchCriteria, pageSize: value, page: 1 });
                                            getReviewPanelMemberList({ ...searchCriteria, pageSize: value, page: 1 });
                                        }}
                                    />
                                </div>
                            </div>
                        </div>
                        <div style={{ marginTop: 15, overflow: 'auto' }}>
                            <CustomTable
                                skipMaxHeight={false}
                                maxHeight={250}
                                rows={searchRows}
                                columns={searchColumns}
                                loading={isMemberLoading}
                            />
                        </div>

                        <div style={{ marginTop: 15 }}>
                            <CustomPagination
                                page={reviewPanelMemberList?.page || 1}
                                pageSize={reviewPanelMemberList?.size || 10}
                                total={reviewPanelMemberList?.total || 0}
                                onPageChange={(page) => {
                                    setSearchCriteria({ ...searchCriteria, page });
                                    getReviewPanelMemberList({ ...searchCriteria, page });
                                }}
                            />
                        </div>
                    </div>
                    <div style={{ borderTop: '2px solid #dcdcdc', marginTop: 15 }}></div>

                    <TextSubHeader style={{ marginTop: 15 }}>Selected Member:</TextSubHeader>

                    <div style={{ marginTop: 10 }}>
                        <CustomTable
                            rows={selectedMember}
                            columns={currentColumns}
                            isDeleteAllow
                            onDelete={deleteRow}
                            loading={isLoading}
                            maxHeight={250}
                            skipMaxHeight={false}
                        />
                    </div>
                </div>
            </Popup>
        </SLayout>
    );
};

export default PanelAddDialog;
